




























































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import moment from 'moment'
import { weMediaSubListColumns } from '../config/columns'
import { CATEGORIES, ALL_GROUPS } from '../config/'
import { ExtraData, Level2Task, SendMessageData, TaskInstance } from '../types/task'
import {
  getSubTaskList,
  getTaskInstance,
  subListColumns,
  recordFinishTime
} from '../../../service/platform'
import { getUrlParams } from '../../../utils/urlUtils'
import ViewTask from '../components//ViewTask.vue'
import ViewAuditHistory from '../components/ViewAuditHistory.vue'
import { USER_ID, USER_GROUPS, BUSINESS_SOURCE_DATA } from '@/service/constant'
import { editResources } from '../api/'
import { getToken, getMd5, uploadAliyunOss, downloadHost } from '@/service/aliyunOssUpload'

@Component({
  components: { ViewTask, ViewAuditHistory }
})
export default class WeMediaSubTaskList extends Vue {
  private resourceId = ''
  private isUploader = false
  private uploading = false
  private get groups() {
    return this.$store.state[USER_GROUPS]
  }
  private columns = weMediaSubListColumns
  private dataSource = []
  private pagination = {
    total: 0,
    current: 1,
    pageSize: 10,
    showTotal: (total, range) => `共${total}条`
  }
  public dataList: Level2Task[] = []
  private task: TaskInstance | {} = {} // 一级任务
  private instance: any | {} = {} // 子任务
  private isShowViewTask = false
  private extraData: ExtraData | {} = {} // 子任务处理时填写信息
  private sendMessageData: SendMessageData | {} = {} // 子任务处理时额外信息

  private showAuditHistory = false

  private visible = false
  private form: any
  private layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 }
  }
  private categories = CATEGORIES
  private sourceDataTypes: any[] = []
  private resources: any = []
  private files: any = []

  private get sourceData() {
    return this.$store.state[BUSINESS_SOURCE_DATA]
  }

  beforeCreate() {
    console.log('init form')
    ;(this as any).form = this.$form.createForm(this)
  }

  mounted() {
    this.loadData()
    this.isUploader = this.groups.includes(ALL_GROUPS[4].id)
  }

  defaultFileList: any = []

  async showUploadModal(status, instance_id: string) {
    const groups = this.$store.state[USER_GROUPS]
    let instance = (await getTaskInstance(instance_id)) as any
    if (!instance || !instance.id) return

    this.instance = instance

    if (['一审资源处理中', '二审资源处理中', '处理中'].includes(status)) {
      this.visible = true
      let instance = (await getTaskInstance(instance_id)) as any
      if (!instance || !instance.id) return
      this.resourceId = instance.relate_id
      const resources = instance.resource.resource_data.map((item: any, index: number) => {
        return {
          uid: `${index + 1}`,
          name: item.name,
          url: item.location,
          status: 'done'
        }
      })
      const defaultFileList = resources.map((item, index) => {
        const name = item.name
        const suffix = name.split('.')[1]
        let newUrl = item.url

        if (['doc', 'docx'].includes(suffix)) {
          newUrl = `https://vip.ow365.cn?i=22595&ssl=1&del=1&furl=${item.url}`
        }

        return {
          uid: item.uid,
          name: item.name,
          url: newUrl,
          status: 'done'
        }
      })

      this.resources = resources
      this.defaultFileList = defaultFileList
      this.form.setFieldsValue({
        business_type: 8001,
        category: instance.resource.category,
        account_name: instance.resource.account_name,
        source: instance.resource.source_name,
        operator: instance.resource.operator,
        publish: moment(instance.resource.publish_at, 'YYYY-MM-DD'),
        title: instance.resource.title
      })
    } else {
      this.reset()
      this.isShowViewTask = true
      this.getFinishTime(instance_id, instance.current_task.id)
    }
  }

  handleBusinessTypeChange(value) {
    const source = this.sourceData[`${value}`]
    this.sourceDataTypes = Object.keys(source).map((item) => {
      return {
        label: source[item],
        value: item
      }
    })
  }

  normFile(e) {
    console.log('Upload event:', e)
    if (Array.isArray(e)) {
      return e
    }
    return e && e.fileList
  }

  @Watch('uploadingList')
  handleUploadingListChange(val) {
    if (val === 0) {
      this.uploading = false
      this.resources = []
    }
  }

  beforeUpload(file: any) {
    if (this.uploadingList === 0) {
      this.resources = []
    }
    this.uploadSingleFile(file)
    return false
  }

  uploadSingleFile(file: any) {
    this.uploading = true
    const handleUploadSuccess = (filename: any, originalFileName: any) => {
      this.uploading = false
      const newUrl = downloadHost + filename

      this.resources.push({
        name: originalFileName,
        url: newUrl
      })
    }

    Promise.all([getToken(), getMd5(file)]).then(([{ oss }, md5]) => {
      const originalFileName = file.name || ''
      let surfix = ''

      if (originalFileName.indexOf('.') > -1) {
        surfix = originalFileName.split('.').pop()
      }

      const newName = 'cguardian-resource/' + (surfix ? `${md5}.${surfix}` : md5)
      const newUploadingItem = {
        file,
        client: oss,
        tempCheckpoint: undefined,
        updateCheckpoint: (checkpoint: any) => {
          console.log('checkpoint', checkpoint)
        },
        cb: (pgs: any) => {
          console.log('pgs', pgs)
        },
        filename: newName,
        // 其他
        name: originalFileName,
        progress: '0%'
      }

      uploadAliyunOss(newUploadingItem).then((retData: any) => {
        handleUploadSuccess(retData.name, newUploadingItem.name)
      })
    })
  }

  private uploadingList = 0

  handleUploadChange(info) {
    let fileList = [...info.fileList]

    fileList = fileList.slice(-1)
    fileList = fileList.map((file) => {
      if (file.response) {
        file.url = file.response.url
      }
      return file
    })

    this.defaultFileList = fileList
    this.uploadingList = fileList.length

    if (!fileList.length) {
      this.resources = []
    }
  }

  previewFile(file) {
    const { name } = file
    const r = this.resources.find((item) => item.name === name)

    if (r) {
      const suffix = r.name.split('.')[1]

      if (['doc', 'docx'].includes(suffix)) {
        window.open(`https://vip.ow365.cn?i=22595&ssl=1&del=1&furl=${r.url}`)
      } else {
        window.open(r.url)
      }
    } else {
      this.$message.info('上传中')
    }
  }

  removeFile(file) {
    const { name } = file
    let index = ''
    this.resources.forEach((r, i) => {
      if (r.name === name) index = i
    })

    if (typeof index === 'number') {
      this.resources.splice(index, 1)
    }
    return true
  }

  // 提交
  async handleSubmit(e) {
    e.preventDefault()
    this.form.validateFields(async (err, fieldsValue) => {
      if (err) return

      const values = {
        publish_at: fieldsValue['publish'].format('YYYY-MM-DD'),
        ...fieldsValue
      }

      if (this.uploadingList === 0) {
        this.resources = []
      }

      const h = this.$createElement

      this.$confirm({
        content: h('div', {}, [
          h('p', '1. 风控审核时间为9:00—18:00；'),
          h(
            'p',
            '2. 针对广告中出现的数据、统计资料、活动及价格等风控无法验证其真实性的内容，请提前咨询GR及法务等相关部门，业务方须确保其内容真实、准确；'
          ),
          h(
            'p',
            '3. 风控只涉及内容安全及广告法相关内容的审核，其它不在风控审核范畴的包括侵权等但不限于的内容请务必与相关部门核实，确保内容真实、准确，并符合相关规定。'
          )
        ]),
        centered: true,
        iconType: 'exclamation-circle',
        onOk: async () => {
          const options = {
            business_type: this.instance.resource.business_type,
            category: this.instance.resource.category,
            account_name: this.instance.resource.account_name,
            title: values.title,
            source: this.instance.resource.source,
            publish_at: values.publish_at,
            operator: this.instance.resource.operator,
            resource_data: [this.resources[this.resources.length - 1]],
            resource_id: this.resourceId
          }
          const res = await editResources(options)

          if (res.success) {
            this.visible = false
            this.resources = []
            this.uploadingList = 0
            this.$message.success('上传成功', 1, () => {
              window.location.reload()
            })
          } else {
            console.log(res.error)
          }
        },
        onCancel() {}
      })
    })
  }

  public async loadData() {
    const task_id = getUrlParams().id
    if (!task_id) return
    let task = await getTaskInstance(task_id)
    this.task = task || {}

    this.getDataList(task_id, 1)
  }

  public async clickShowViewTask(instance_id: string) {
    let instance = (await getTaskInstance(instance_id)) as TaskInstance
    if (!instance || !instance.id) return

    this.instance = instance
    this.reset()
    this.isShowViewTask = true
    this.getFinishTime(instance_id, instance.current_task.id)
  }

  public async clickShowAuditHistory(instance_id: string) {
    let instance = (await getTaskInstance(instance_id)) as TaskInstance
    if (!instance || !instance.id) return

    this.instance = instance
    this.showAuditHistory = true
  }

  private async getDataList(task_id, pageNum) {
    const { count, current_page, contents } = await getSubTaskList(
      task_id,
      pageNum,
      this.pagination.pageSize
    )
    let temp = contents
    const dataList = temp.map((item, index) => ({
      index: index * this.pagination.pageSize + 1,
      ...item
    }))

    this.dataList = dataList
    this.pagination.total = count
    this.pagination.current = current_page
  }

  private handlePaginationChange(pagination) {
    const task_id = getUrlParams().id
    if (!task_id) return

    this.getDataList(task_id, pagination.current)
  }

  private async reload() {
    await this.loadData()
    if (this.dataList.length == 0) {
      this.$router.replace({ path: '/platform/my-task' }).catch((_) => {})
    }
  }

  private reset() {
    const instance = this.instance as TaskInstance
    this.extraData = {
      instance_id: instance.id,
      task_id: instance.current_task.id,
      pic_data: [],
      word_data: [],
      content_data: [{ content: '', sensitive_type: [] }],
      auditor: this.$store.state[USER_ID] || '', // 图片审核传递当前用户ID
      subject_name: instance.resource && instance.resource.subject_name,
      business_type_name: instance.resource && instance.resource.business_type_name,
      doc_id: instance.resource && instance.resource.doc_id,
      resource_url: instance.resource && instance.resource.resource_url,
      // 合并接口的字段。
      detail: '',
      img: ''
    }
    const extraData = this.extraData as ExtraData
    if (instance && instance.resource && instance.resource.sensitive_words.length > 0) {
      extraData.word_data = instance.resource.sensitive_words.map((item) => ({
        word_name: item.name,
        sensitive_type: item.sensitive_type
      }))
    } else {
      extraData.word_data = []
    }

    this.sendMessageData = {
      instance_id: instance.id,
      img: '',
      detail: ''
    }
  }

  private onChangeShowViewTask(val: boolean) {
    this.isShowViewTask = val
  }
  // 记录点击'处理'按钮
  public async getFinishTime(id, task) {
    let data = {
      instance_id: id,
      task_id: task,
      step: 'deal'
    }
    await recordFinishTime(data)
  }
}
